<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chaptitle"><a id="walk"></a><big>walking the sacred spiral</big></h1>
<p class="center"><img alt="Image" src="images/u1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_sacredspiral.vue?6369a592